import { Box, 
  // IconButton, 
  Typography } from "@mui/material";
import { 
  // color, 
  styled } from "@mui/system";
import React from "react";
// import { FaPlus } from "react-icons/fa";
// import { useModal } from "../../../contexts/modalContext";
// import { StyledButton } from "../../../pages/auth/Login";
// import { useNavigate } from "react-router-dom";

import { FaPaperPlane } from "react-icons/fa";

const StyledHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingBottom: "1rem",
  paddingRight: "10px",
}));

const StyledInvitationIcon = styled(FaPaperPlane)(({ theme }) => ({
  marginLeft: 16,
  fontSize: 24,
  color: theme.palette.primary.main,
  "&:hover": {
    cursor: "pointer",
  },
}));

const EventsHeader = () => {
  return (
    <StyledHeader>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 1,
          alignItems: "center",
          marginTop: 5,
        }}
      >
        <Typography
          ml={2}
          variant="h1"
          fontWeight={700}
          fontSize={26}
          sx={{ alignSelf: "flex-end" }}
          color="primary.main"
        >
          Invitations
        </Typography>
        <StyledInvitationIcon />
      </Box>
    </StyledHeader>
  );
};

export default EventsHeader;
